/**
 * Created by tdunham on 8/30/2017.
 */

export class Phrase {

	public id:              number;             // The ID number of this tag in the Angular2 database.
	public search:          string;             // The search text ("Achilles").
	public tag:             string;             // The name of the tag ("injured").

	constructor( values: Object = {} ) {
		Object.assign( this, values );
	}

}



// WEBPACK FOOTER //
// ./src/app/services/tag/phrase.ts